import { render, staticRenderFns } from "./info_feedback.vue?vue&type=template&id=0f80c55b&scoped=true&"
import script from "./info_feedback.vue?vue&type=script&lang=ts&"
export * from "./info_feedback.vue?vue&type=script&lang=ts&"
import style0 from "./info_feedback.vue?vue&type=style&index=0&id=0f80c55b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f80c55b",
  null
  
)

export default component.exports